import { getSrc as getGatsbySrc } from 'gatsby-plugin-image';
import { Media } from '../models/file';

function getFormat(img: Media): string | null {
    let format: string | null = null;

    if (img?.format) {
        format = img.format;
    }

    if (!format) {
        const src = getSrc(img);
        const extension = src.split('.').pop();
        if (src && extension) {
            format = extension;
        }
    }

    return format;
}

function isImage(img: Media): boolean {
    const format = getFormat(img);
    return format ? !['mp4', 'webm', 'mov'].includes(format) : true;
}

export function getImage(img: Media) {
    if (!img) return null;

    const alt = img?.alt ?? img?.title ?? '';

    if (img?.gatsbyImageData) {
        return {
            alt,
            src: img.gatsbyImageData,
            isImage: true,
        };
    }

    if (img?.src || img?.publicURL || img?.url) {
        return {
            alt,
            src: img.src || img.publicURL || img.url,
            ...(img.width && { width: img.width }),
            ...(img.height && { height: img.height }),
            ...(img.format && { extension: img.format }),
            isImage: isImage(img),
        };
    }

    if (typeof img === 'string') {
        return {
            src: img,
            isImage: isImage(img),
            extension: getFormat(img),
        };
    }

    return null;
}

export function getSrc(img: Media): string {
    if (!img) return '';

    if (img?.gatsbyImageData) {
        const src = getGatsbySrc(img);
        return src || '';
    }

    if (img?.src) return img.src;
    if (img?.publicURL) return img.publicURL;
    if (img?.url) return img.url;
    if (typeof img === 'string') return img;

    return '';
}
